module.exports = __webpack_public_path__ + "images/category_lp/alcohol/assessment_achievements/6_42f2a45c9c0b1c11b6d4cf109e6db137.jpg";